import ContractFee from './index';

export default {
    path: '/home/withdraw',
    component: ContractFee,
    children: []
}